import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BasicAdditionalInformationViewComponent } from '@account/basic-additional-information-view/basic-additional-information-view.component';
import { AuthGuard } from '@auth/guards/auth.guard';
import { ResetPasswordGuard } from '@auth/guards/reset-password.guard';
import { LoginComponent } from './login/login.component';
import { RecoverPasswordViewComponent } from './change-password/recover-password-view/recover-password-view.component';
import { ChangePasswordInstructionViewComponent } from './change-password/change-password-instruction-view/change-password-instruction-view.component';
import { LinkExpiredViewComponent } from './change-password/link-expired-view/link-expired-view.component';
import { RestorePasswordViewComponent } from './change-password/restore-password-view/restore-password-view.component';
import { IdentityValidationComponent } from './identity-validation/identity-validation.component';
import { UnifiedHomeComponent } from './unified-home/unified-home.component';
import { ReferralsComponent } from './referrals';
import { PaymentStatusComponent } from './payment-status/payment-status.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'login/:isNewLoan', component: LoginComponent },
  { path: 'home', component: UnifiedHomeComponent, canActivate: [AuthGuard] },
  { path: 'changePassword', component: RecoverPasswordViewComponent },
  { path: 'instructionPassword', component: ChangePasswordInstructionViewComponent },
  { path: 'resetPassword/:key', component: RestorePasswordViewComponent, canActivate: [ResetPasswordGuard] },
  { path: 'linkExpired', component: LinkExpiredViewComponent },
  { path: 'identityValidation', component: IdentityValidationComponent, canActivate: [AuthGuard] },
  { path: 'basicAdditionalInformation', component: BasicAdditionalInformationViewComponent, canActivate: [AuthGuard] },
  { path: 'referrals', component: ReferralsComponent, canActivate: [AuthGuard] },
  { path: 'payment-status', component: PaymentStatusComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
